import axiosClient from "./axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";
const userSystemApi = {
  getAll: (params) => {
    const url = "users";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },
  createUser: (params) => {
    const url = "users";
    return axiosClient.post(url, params);
  },
  updateUser: (params) => {
    const url = "users/";
    const payload = {
      fullName: params.fullName,
      email: params.email,
      active: params.active,
      roles: params.roles,
    };
    return axiosClient.patch(url + params.id, payload);
  },
  deleteUser: (id) => {
    const url = "users/";
    return axiosClient.delete(url + id);
  },
  deleteUsers: (params) => {
    const url = "users";
    console.log("params", params);
    return axiosClient.delete(url, { params });
  },
  resetPassword: (id) => {
    const url = "users/resetPassword/";
    return axiosClient.get(url + id);
  },
  changePassword: (data) => {
    const url = "auth/change-password";
    return axiosClient.post(url, data);
  },
};

export default userSystemApi;
